import { USERS_USER_DATA_WINDOW_VALUE } from "../../../constants/users";

export default function setUser(userData) {
  if (typeof window !== "undefined") {
    window[USERS_USER_DATA_WINDOW_VALUE] = userData;
  }
}
